import { getResponseToState } from "@mappers/getCartMapper";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { addInstallationAppointmentRoute } from "@api-routes/eirSalesFacade";
import { IEirSalesAddInstallationAppointmentPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesAddInstallationAppointmentPayload";
import { IEirSalesAddInstallationAppointmentResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesAddInstallationAppointmentResponse";

export const patchAddInstallationAppointment = (
    prospectReference: string,
    offerId: number,
    payload: IEirSalesAddInstallationAppointmentPayload,
    options: IFetchOptions = {}
): Promise<IEirSalesAddInstallationAppointmentResponse | undefined> =>
    fetcher<IEirSalesAddInstallationAppointmentResponse>(addInstallationAppointmentRoute(prospectReference, offerId), {
        method: "PATCH",
        body: payload,
        mapper: getResponseToState,
        ...options,
    });
